import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import pick from 'lodash/pick';
import { GENDERS, GRADE_LEVEL } from '../containers/CollegeEvents/graphql/fetchCollegeEvents';

// Application
export const CLICKTRACKING_APPLICATION_NAVIANCE_COLLEGE_EVENTS_PAGE = 'naviance_college_events_page';

// Location
export const CLICKTRACKING_LOCATION_EVENTS_LIST = 'events_list';
export const CLICKTRACKING_LOCATION_EVENTS_HEADER = 'college_events_header';

// Type
export const CLICKTRACKING_TYPE_COLLEGE_EVENT_CARD_SHOWN = 'college_event_card_shown';
export const CLICKTRACKING_TYPE_COLLEGE_EVENT_SHOW_DETAILS = 'college_event_show_details_clicked';
export const CLICKTRACKING_TYPE_COLLEGE_EVENT_REGISTRATION_LINK = 'college_event_registration_link_clicked';
export const CLICKTRACKING_TYPE_COLLEGE_EVENT_PROFILE_LINK = 'college_profile_link_clicked';
export const CLICKTRACKING_TYPE_COLLEGE_RECOMMENDED_BANNER = 'college_event_recommended_banner_clicked';

// Format a single click tracking event
export const getSingleClickEvent = (event, userData, filters) => {
  return {
    ...event,
    ...getClickTrackUser(userData),
    ...getClickSearchCriteria(filters),
  };
};

// Format click track event for the list of shown college vents
export const getBatchClickEvent = (events, userData, filters) => {
  const payloads = events.map((event) => {
    return {
      ...getClickTrackEventCommon(event),
    };
  });
  const batchEvent = {
    application: CLICKTRACKING_APPLICATION_NAVIANCE_COLLEGE_EVENTS_PAGE,
    location: CLICKTRACKING_LOCATION_EVENTS_LIST,
    type: CLICKTRACKING_TYPE_COLLEGE_EVENT_CARD_SHOWN,
    ...getClickTrackUser(userData),
    ...getClickSearchCriteria(filters),
    ...(payloads && payloads.length > 0 && { payloads }),
  };
  return batchEvent;
};

// Format specific click track user data
export const getClickTrackUser = ({ userData, highSchool }) => {
  const { act, classYear, defaultGpa, gender = 'U', gradeLevel, highSchoolId, sat, address } = userData;
  const { ceebCode } = highSchool;
  const state = get(address, 'state', get(highSchool, 'state'));
  const zip = get(address, 'zip', get(highSchool, 'zip'));
  return {
    ...(act && { act }),
    ...(ceebCode && { ceeb: ceebCode }),
    ...(classYear && { classYear: classYear.toString() }),
    ...(defaultGpa && { gpa: defaultGpa }),
    ...(gender && { gender: GENDERS[gender] }),
    ...(gradeLevel && { gradeLevel: GRADE_LEVEL[gradeLevel] }),
    ...(highSchoolId && { highSchoolId }),
    ...(sat && { sat }),
    ...(state && { state }),
    ...(zip && { zipCode: zip }),
  };
};

// Format specific click track event common data
export const getClickTrackEventCommon = ({ id, recommendedAudienceProfile, college: { scid } }) => {
  return {
    eventId: id,
    scid: scid || '',
    ...(recommendedAudienceProfile && { matchedFilterId: recommendedAudienceProfile.id }),
  };
};

// Format click track filter/search criteria data
export const getClickSearchCriteria = (filters) => {
  const { distance = {}, startDate, endDate, majors, states, sizes } = filters;
  const { miles, zipCode } = distance;
  const matchedSearchCriteria = {
    ...pick(filters, ['name', 'recommended', 'virtual']),
    ...(!isEmpty(majors) && { majors }),
    ...(!isEmpty(states) && { states }),
    ...(!isEmpty(sizes) && { sizes }),
    ...(startDate && { dateFrom: startDate }),
    ...(endDate && { dateTo: endDate }),
    ...(miles && { radius: miles }),
    ...(zipCode && { zipCode }),
  };
  return !isEmpty(matchedSearchCriteria) ? { matchedSearchCriteria } : undefined;
};

// College event - sign up
export const getRegistrationLinkClicked = (event) => {
  return {
    application: CLICKTRACKING_APPLICATION_NAVIANCE_COLLEGE_EVENTS_PAGE,
    location: CLICKTRACKING_LOCATION_EVENTS_LIST,
    type: CLICKTRACKING_TYPE_COLLEGE_EVENT_REGISTRATION_LINK,
    ...getClickTrackEventCommon(event),
  };
};

// College event - view more details
export const getCollegeEventDetailsClicked = (event) => {
  return {
    application: CLICKTRACKING_APPLICATION_NAVIANCE_COLLEGE_EVENTS_PAGE,
    location: CLICKTRACKING_LOCATION_EVENTS_LIST,
    type: CLICKTRACKING_TYPE_COLLEGE_EVENT_SHOW_DETAILS,
    ...getClickTrackEventCommon(event),
  };
};

// College event - college profile name
export const getCollegeProfileLinkClicked = (event) => {
  return {
    application: CLICKTRACKING_APPLICATION_NAVIANCE_COLLEGE_EVENTS_PAGE,
    location: CLICKTRACKING_LOCATION_EVENTS_LIST,
    type: CLICKTRACKING_TYPE_COLLEGE_EVENT_PROFILE_LINK,
    ...getClickTrackEventCommon(event),
  };
};

export const getRecommendedBannerClicked = () => {
  return {
    application: CLICKTRACKING_APPLICATION_NAVIANCE_COLLEGE_EVENTS_PAGE,
    location: CLICKTRACKING_LOCATION_EVENTS_HEADER,
    type: CLICKTRACKING_TYPE_COLLEGE_RECOMMENDED_BANNER,
    scid: '',
  };
};
